import React from 'react';
import moment from 'moment-timezone';

const Live = ({ match, matchDate, selectedCompetition }) => {
    const siteURL = process.env.REACT_APP_SITE_URL;
    const apiUrl = process.env.REACT_APP_API_URL;
    const imageURL = process.env.REACT_APP_IMAGE_URL;
    const defaultPlayerImage = `${imageURL}player-thumb.jpg`;
    const defaultTeamImage = `${imageURL}default-team-logo.png`;
    const handleImageError = (e) => {
        e.target.src = defaultPlayerImage;
    };
    const handleTeamImageError = (e) => {
        e.target.src = defaultTeamImage;
    };
    // const getMatchURL = (match, selectedCompetition) => {
    //     // Get the current path from window location
    //     const currentPath = window.location.pathname;

    //     // Base query parameters
    //     const baseParams = `type=scorecard&mId=${match.MatchID}&cId=${match.CompetitionID}&dId=${match.DivisionID}`;

    //     // Remove trailing slash if exists
    //     const cleanPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;

    //     // Get the last segment of the path
    //     const pathSegments = cleanPath.split('/').filter(Boolean);
    //     const lastSegment = pathSegments[pathSegments.length - 1];
    //     console.log(lastSegment);
    //     // Construct the full URL with the current path segment
    //     return `${siteURL}${lastSegment}/?${baseParams}`;
    // };

    const getMatchURL = (match, selectedCompetition) => {
        // Base query parameters
        const baseParams = `type=scorecard&mId=${match.MatchID}&cId=${match.CompetitionID}&dId=${match.DivisionID}`;

        // Check if we're in test environment
        if (process.env.REACT_APP_API_URL_ENV === 'test') {
            const testUrl = `${siteURL}?${baseParams}`;
            console.log('Test Environment URL:', testUrl);
            return testUrl;
        }

        // For non-test environment
        const currentPath = window.location.pathname;
        const cleanPath = currentPath.endsWith('/') ? currentPath.slice(0, -1) : currentPath;
        const pathSegments = cleanPath.split('/').filter(Boolean);
        const lastSegment = pathSegments[pathSegments.length - 1];
        const finalUrl = `${siteURL}${lastSegment}/?${baseParams}`;
        return finalUrl;
    };

    const shouldDisplayWicket = (wicket) => {
        return (wicket != 10);
    };
    return (
        <div className="matchBox liveStrip" key={match.MatchID}>
            <div className="live-tag">Live <span></span></div>
            <div className="uniform-grid">
                <div className="matchBox__left sm-flex sm-align-center">
                    <div className="matchTeams sm-flex sm-align-center">
                        {match.HomeTeamID ? (
                            <>
                                <div className="tLogo">
                                    <img alt={match.HomeTeamName} onError={handleTeamImageError}
                                        src={match.MatchHomeTeamLogo || match.HomeTeamLogo || defaultTeamImage} />
                                </div>
                                <div className="teamNames ">{match.HomeTeamName}</div>

                                <div className="runBox">
                                    {match.HomeTeamID == match.FirstBattingTeamID ? (
                                        <div className="teamScore" >
                                            {match['1FallScore'] &&
                                                <span className="runs " >
                                                    {match['1FallScore']}
                                                    {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}</span>
                                            }
                                            {match['1FallOvers'] &&
                                                <span className="overs" >({match['1FallOvers']}) </span>}
                                        </div>
                                    ) : (
                                        <div className="teamScore" >
                                            {match['2FallScore'] &&
                                                <span className="runs " >   {match['2FallScore']}  {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}</span>
                                            }
                                            {match['2FallOvers'] &&
                                                <span className="overs" >({match['2FallOvers']} )</span>}
                                        </div>
                                    )}

                                    {match.CurrentInnings > 2 && (
                                        <>
                                            {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                            {match.HomeTeamID == match.SecondInningsFirstBattingID ? (
                                                <div className="teamScore" >
                                                    {match['3FallScore'] &&
                                                        <span className="runs " >
                                                            {match['3FallScore']}  {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}</span>
                                                    }{match['3FallOvers'] &&
                                                        <span className="overs" >({match['3FallOvers']} )</span>}
                                                </div>
                                            ) : (<>
                                                {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}

                                                <div className="teamScore" >
                                                    {match['4FallScore'] &&
                                                        <span className="runs " >   {match['4FallScore']}  {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}</span>
                                                    }{match['4FallOvers'] &&
                                                        <span className="overs" >({match['4FallOvers']}) </span>}
                                                </div></>
                                            )}
                                        </>
                                    )}

                                </div>
                            </>
                        ) : (
                            <div className="matchTeams sm-flex sm-align-center">
                                {/* First Batting Team */}
                                <div className="tLogo">
                                    <img alt={match.FirstBattingTeamName} onError={handleTeamImageError}
                                        src={match.HomeTeamLogo || defaultTeamImage} />
                                </div>
                                <div className="teamNames">{match.FirstBattingTeamName}</div>
                                <div className="runBox">
                                    <div className="teamScore">
                                        {match['1FallScore'] && (
                                            <span className="runs">
                                                {match['1FallScore']} {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}
                                            </span>
                                        )}
                                        {match['1FallOvers'] && <span className="overs">({match['1FallOvers']})</span>}
                                    </div>
                                    {match.CurrentInnings > 2 && (
                                        <>
                                            {match.FirstBattingTeamID == match.SecondInningsFirstBattingID ? (
                                                <>
                                                    {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                    <div className="teamScore">
                                                        {match['3FallScore'] && (
                                                            <span className="runs">
                                                                {match['3FallScore']} {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}
                                                            </span>
                                                        )}
                                                        {match['3FallOvers'] && <span className="overs">({match['3FallOvers']})</span>}
                                                    </div></>
                                            ) : (
                                                <>
                                                    {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                    <div className="teamScore">
                                                        {match['4FallScore'] && (
                                                            <span className="runs">
                                                                {match['4FallScore']} {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}
                                                            </span>
                                                        )}
                                                        {match['4FallOvers'] && <span className="overs">({match['4FallOvers']})</span>}
                                                    </div></>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}

                    </div>
                    <div className="tVs">vs </div>

                    <div className="matchTeams sm-flex sm-align-center">
                        {match.AwayTeamID ? (
                            <>
                                <div className="tLogo">
                                    <img alt={match.AwayTeamName} onError={handleTeamImageError}
                                        src={match.MatchAwayTeamLogo || match.AwayTeamLogo || defaultTeamImage} />
                                </div>
                                <div className="teamNames " >{match.AwayTeamName}</div>
                                <div >
                                    <div className="runBox">
                                        {match.AwayTeamID == match.FirstBattingTeamID ? (
                                            <div className="teamScore">
                                                {match['1FallScore'] &&
                                                    <span className="runs " >   {match['1FallScore']}  {shouldDisplayWicket(match['1FallWickets']) && `/${match['1FallWickets']}`}</span>
                                                }
                                                {match['1FallOvers'] &&
                                                    <span className="overs" >({match['1FallOvers']}) </span>}
                                            </div>) : (
                                            <div className="teamScore" >
                                                {match['2FallScore'] &&
                                                    <span className="runs " >  {match['2FallScore']}  {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}</span>
                                                }
                                                {match['2FallOvers'] &&
                                                    <span className="overs" >({match['2FallOvers']} )                                  </span>
                                                }
                                            </div>
                                        )}
                                        {match.CurrentInnings > 2 && (
                                            <>
                                                {match.AwayTeamID == match.SecondInningsFirstBattingID ? (
                                                    <>                                                {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}

                                                        <div className="teamScore" >
                                                            {match['3FallScore'] &&
                                                                <span className="runs " >
                                                                    {match['3FallScore']}  {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}</span>
                                                            }
                                                            {match['3FallOvers'] &&
                                                                <span className="overs" >({match['3FallOvers']} )</span>}
                                                        </div>
                                                    </>) : (<>
                                                        {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}

                                                        <div className="teamScore" >
                                                            {match['4FallScore'] &&
                                                                <span className="runs " >   {match['4FallScore']}  {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}</span>
                                                            }
                                                            {match['4FallOvers'] &&
                                                                <span className="overs" >({match['4FallOvers']}) </span>}
                                                        </div>
                                                    </>)}
                                            </>
                                        )}

                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="matchTeams sm-flex sm-align-center">
                                <div className="tLogo">
                                    <img alt={match.SecondBattingTeamName} onError={handleTeamImageError}
                                        src={match.AwayTeamLogo || defaultTeamImage} />
                                </div>
                                <div className="teamNames">{match.SecondBattingTeamName}</div>
                                <div className="runBox">
                                    <div className="teamScore">
                                        {match['2FallScore'] && (
                                            <span className="runs">
                                                {match['2FallScore']} {shouldDisplayWicket(match['2FallWickets']) && `/${match['2FallWickets']}`}
                                            </span>
                                        )}
                                        {match['2FallOvers'] && <span className="overs">({match['2FallOvers']})</span>}
                                    </div>
                                    {match.CurrentInnings > 2 && (
                                        <>
                                            {match.SecondBattingTeamID == match.SecondInningsFirstBattingID ? (
                                                <>
                                                    {match['3FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                    <div className="teamScore">
                                                        {match['3FallScore'] && (
                                                            <span className="runs">
                                                                {match['3FallScore']} {shouldDisplayWicket(match['3FallWickets']) && `/${match['3FallWickets']}`}
                                                            </span>
                                                        )}
                                                        {match['3FallOvers'] && <span className="overs">({match['3FallOvers']})</span>}
                                                    </div>
                                                </>
                                            ) : (<>
                                                {match['4FallScore'] && <span className="amp" style={{ fontSize: '16px' }}>&</span>}
                                                <div className="teamScore">
                                                    {match['4FallScore'] && (
                                                        <span className="runs">
                                                            {match['4FallScore']} {shouldDisplayWicket(match['4FallWickets']) && `/${match['4FallWickets']}`}
                                                        </span>
                                                    )}
                                                    {match['4FallOvers'] && <span className="overs">({match['4FallOvers']})</span>}
                                                </div></>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                <div className="matchBox__right sm-flex sm-align-center">
                    <div className="match-tournament-name">
                        {match.CompetitionName ||
                            (selectedCompetition?.CompetitionID === match.CompetitionID && selectedCompetition?.CompetitionName)}
                    </div>
                    <div className="matchInfom sm-flex">
                        <div className="matchInfom_left">
                            <div className="match-order">
                                {/* <span className="" >{match.MatchOrder}</span> */}
                                <span className="ng-binding"></span>
                                <span>{match.MatchDateNew} </span>                                           </div>
                            <div className="match-ground-name">
                                <span className="matGround " >{match.GroundName || "N/A"}</span>
                                <span className="">,&nbsp; </span>
                                <span className="matPlace " >{match.city || "N/A"} </span>
                            </div>
                        </div>
                        <div className="matchInfom_right">
                            {(match.Comments !== undefined && match.Comments !== '') && (
                                <div className="matchResult">
                                    {match.Comments}
                                </div>
                            )}
                            {(!match.MatchComments && match.TossDetails !== '') && (
                                <div className="matchSummary">
                                    {match.TossDetails}
                                </div>
                            )}
                            <div className="mt-sld_bottom">
                                <div className="cr-ply-info">
                                    {match.CurrentStrikerName && (
                                        <>
                                            <div className="cr-tit">Batter</div>
                                            <div className="bm-info cr-bm">
                                                <div className="bm-in">
                                                    <span className="str">• </span>
                                                    <div className="player__pic">
                                                        <img
                                                            src={match.StrikerImage || defaultPlayerImage}
                                                            alt={match.CurrentStrikerName}
                                                            onError={(e) => { e.target.src = defaultPlayerImage }}
                                                            title={match.CurrentStrikerName}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="bm-in">
                                                    {`${match.CurrentStrikerName} ${match.StrikerRuns} (${match.StrikerBalls}b ${match.StrikerFours}x4s ${match.StrikerSixes}x6s) SR: ${match.StrikerSR}`}
                                                </div>
                                            </div>
                                            <div className="bm-info">
                                                <span className="str">• </span>
                                                <div className="player__pic str">
                                                    <img
                                                        src={match.NonStrikerImage || defaultPlayerImage}
                                                        alt={match.CurrentNonStrikerName}
                                                        onError={(e) => { e.target.src = defaultPlayerImage }}
                                                        title={match.CurrentNonStrikerName}
                                                    />
                                                </div>
                                                {`${match.CurrentNonStrikerName} ${match.NonStrikerRuns} (${match.NonStrikerBalls}b ${match.NonStrikerFours}x4s ${match.NonStrikerSixes}x6s) SR: ${match.NonStrikerSR}`}
                                            </div>
                                        </>
                                    )}
                                </div>
                                <div className="cr-ply-info">
                                    {match.CurrentBowlerName && (
                                        <>
                                            <div className="cr-tit">Bowler</div>
                                            <div className="bw-info">
                                                <span className="str">• </span>
                                                <div className="player__pic">
                                                    <img
                                                        src={match.BowlerImage || defaultPlayerImage}
                                                        onError={(e) => { e.target.src = defaultPlayerImage }}
                                                        title={match.CurrentBowlerName}
                                                        alt=""
                                                    />
                                                </div>
                                                {`${match.CurrentBowlerName} ${match.BowlerWickets}/${match.BowlerRuns} (${match.BowlerOvers} ov) Econ: ${match.BowlerEconomy}`}
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="btnWrap">

                        <a href={getMatchURL(match, selectedCompetition)} className="btnScorecard">
                            <span className="ng-binding"></span>Match Centre
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Live;